$(function() {

  window.removeKit = async function (kitId) {
    const cart = await fetch('/cart.js').then(r => r.json());

    const updates = {};
    cart.items.forEach(item => {
      // remove plan itself OR add-ons linked to it
      if (item.properties?.kit_id == kitId || item.id == kitId) {
        updates[item.key] = 0;
      }
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    window.location.reload(); // refresh cart
  }

});